import { PurchaseData } from "@lib/types";
import style from "../PurchaseFlow.module.scss";

const GiftCardSummary = ({purchaseData}: {purchaseData: PurchaseData}) => {


    return (
        <div className={style.giftcardsummary}>
            <p><strong>Amount:</strong> ${purchaseData.amount}</p>
            <p><strong>Purchaser Name:</strong> {purchaseData.purchaserDetails.purchaserName}</p>
            <p><strong>Purchaser Email:</strong> {purchaseData.purchaserDetails.purchaserEmail}</p>
            <p><strong>Purchaser Phone:</strong> {purchaseData.purchaserDetails.purchaserPhone}</p>
            <p><strong>Would you like to send this as a gift?:</strong> {purchaseData.gift ? 'Yes' : 'No'}</p>
            {purchaseData.gift && purchaseData.recipientDetails && (
                <>
                    <p><strong>Recipient Name:</strong> {purchaseData.recipientDetails.recipientName}</p>
                    <p><strong>Recipient Email:</strong> {purchaseData.recipientDetails.recipientEmail}</p>
                    <p><strong>Sender Name:</strong> {purchaseData.recipientDetails.senderName}</p>
                    <p><strong>Message:</strong> {purchaseData.recipientDetails.message}</p>
                </>
            )}
        </div>
    );
};

export default GiftCardSummary;